import React from 'react'
import { createRoot } from 'react-dom/client'
import PassportApp from './page'

const root = createRoot(document.getElementById('root'))
root.render(<PassportApp />)
